
import { Engagement } from "./engagement.model";
export class EngagementList {
    results?: Engagement[];
    count?: number;
    page?: number;
    page_size?: number;

    constructor() {
        this.results = []
      //  this.pagination = <Pagination>{};
    }
}


//this should be removed after the API is updated
export class Manager {
  id: string;
  firstName: string;
  lastName: string;
  constructor() {
      this.id = "";
      this.firstName = "";
      this.lastName = "";
  }
}
